import { useCallback, useEffect } from "react";
import { getCurrentUser } from "../common/ApiUtils";
import C from "../common/ReductTypeConstants";
import { logout } from "../reduce/actions";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const isPublicPath = (pathname) =>
  pathname.startsWith("/forgottenPassword/") || pathname.startsWith("/aprslogbook");

const LoginHandler = ({ dispatchUser, dispatchLogout, dispatchAuthCheckComplete }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const loadCurrentUser = useCallback(() => {
    if (isPublicPath(location.pathname)) {
      dispatchAuthCheckComplete();
      return;
    }

    getCurrentUser()
        .then(response => {
          dispatchUser(response);
          dispatchAuthCheckComplete();
        })
        .catch(error => {
          console.error("Failed to load current user:", error);
          dispatchLogout();
          dispatchAuthCheckComplete();
          if (!location.pathname.startsWith("/login")) {
            navigate("/login", { replace: true, state: { from: location } });
          }
        });
  }, [dispatchAuthCheckComplete, dispatchLogout, dispatchUser, location, navigate]);

  useEffect(() => {
    loadCurrentUser();
  }, [loadCurrentUser]);

  return null; // No UI needed
};

const mapDispatchToProps = (dispatch) => ({
  dispatchUser: (load) => dispatch({ type: C.USER, payload: load }),
  dispatchLogout: () => dispatch(logout()),
  dispatchAuthCheckComplete: () => dispatch({ type: C.AUTH_CHECK_COMPLETE }),
});

export default connect(null, mapDispatchToProps)(LoginHandler);
